module.exports = __webpack_public_path__ + "img/illustration.57641b18.svg";